import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PrerequisiteRevisionItem, PrerequisiteRevision } from '../models';

export class PrerequisiteRevisionApi extends ApiModule {
  protected endpoint = '/prerequisite-revision';

  public async pagePrerequisiteRevisions(params: any) {
    return this.api.post<PaginatedResponseData<PrerequisiteRevisionItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPrerequisiteRevisionDetails(id: number) {
    return this.api.get<PrerequisiteRevision>(`${this.endpoint}?id=${id}`);
  }

  public savePrerequisiteRevision(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePrerequisiteRevision(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public loadPrerequisiteRevisionCompareData(prerequisiteId: number, prerequisiteRevisionId: number) {
    return this.api.get<any>(`${this.endpoint}/load-compare-data?prerequisiteId=${prerequisiteId}&prerequisiteRevisionId=${prerequisiteRevisionId}`);
  }
}
